<template>
    <div id="fileList">
      <CRow class="mb-3 search-panel">
        <CCol xs="12" sm="6" md="4" lg="4" xl="2">
          <div class="form-group">
            <label for="datepicker">Từ ngày - đến ngày</label>
            <DatePicker id="datepicker" v-model="dateRange" locale="vi"
                        :masks="{ input: 'DD/MM/YYYY', data : 'DD/MM/YYYY' }" :popover="{ visibility: 'click' }" is-range class="datepicker">
              <template v-slot="{ inputValue, inputEvents }">
                <input
                  :value="inputValue.start + ' - ' + inputValue.end"
                  v-on="inputEvents.start"
                  class="border px-2 py-1 rounded focus:outline-none focus:border-indigo-300"
                  readonly
                />
              </template>
            </DatePicker>
          </div>
        </CCol>
        <!-- <CCol xs="12" sm="4" md="4" lg="4" xl="2" v-if="$hasAuthor('ROLE_ADMIN') || $hasAuthor('ROLE_PROVINCE')">
          <BaseSelect :options="districtCodeInput.options" :data="districtCodeInput.data"
                      ref="districtCodeInput"></BaseSelect>
        </CCol>
        <CCol xs="12" sm="4" md="4" lg="4" xl="2" v-if="!$hasAuthor('ROLE_WARD')">
          <BaseSelect :options="wardCodeInput.options" :data="wardCodeInput.data" ref="wardCodeInput"></BaseSelect>
        </CCol> -->
        <CCol xs="12" sm="6" md="4" lg="4" xl="2">
          <BaseInput
            :options="titleInput.options"
            :data="titleInput.data"
            :listener="titleInput.listener"
          />
        </CCol>
        <CCol>
          <div class="form-group">
            <label style="color: white"></label>
            <div style="margin-top: 10px">
              <CButton
                style="float: right; margin-left: 5px"
                color="primary"
                v-c-tooltip.hover="'Tải lại'"
                class="btn-action-primary"
                @click="loadDataMainTable(true)">
                <i class="fa fa-refresh"></i>&nbsp; Tải lại
              </CButton>
              <CButton
                style="float: right; margin-left: 5px"
                color="primary"
                v-c-tooltip.hover="'Thêm mới'"
                class="btn-action-primary"
                @click="$router.push('/play-list/add.html')">
                <i class="fa fa-plus"></i>&nbsp; Thêm mới
              </CButton>
            </div>
          </div>
        </CCol>
      </CRow>
      <CRow class="row-2">
  
      </CRow>
      <CCard class="content-fade-in mt-3p5">
        <CCardBody>
          <BaseTable
            :options="mainTable.options"
            :slots="mainTable.slots"
            :dataSource="mainTable.dataSource"
            ref="mainTable"
          >
            <template #index="{ index }">
              <td>{{ $refs.mainTable.getTotalElementByPage + index }}</td>
            </template>
  
            <template #createDate="{ item }">
              <td v-if="item.createDate != null">
                {{ $helper.formatDateDDMMYYYYHHMM(item.createDate) }}
              </td>
              <td v-else></td>
            </template>
            <template #description="{ item }">
              <td>
                <span :key="item.description" class="description" v-c-tooltip.hover="item.description">{{
                    item.description
                  }}</span>
              </td>
            </template>
            <template #action="{ item }">
              <td class="action-btn-group">
                <div class="action-btn-wrapper">
                  <CButton
                    color="danger"
                    variant="outline"
                    square
                    size="sm"
                    v-c-tooltip.hover="'Xóa'"
                    @click="setupSelectOneAction('delete_one', item.id, item.title)">
                    <CIcon name="cil-trash"/>
                  </CButton>
                </div>
              </td>
            </template>
          </BaseTable>
        </CCardBody>
      </CCard>
  
      <ModalConfirm :actionTypeMapping="actionData.actionTypeMapping"
                    ref="actionModal"></ModalConfirm>
  
      <BaseFormLoading :loading="loading.value"></BaseFormLoading>
      
    </div>
  </template>
  
  <script>
  import BaseTable from "@/views/base/BaseDataTable";
  import ModalConfirm from "@/views/base/BaseModalConfirm";
  import BaseInput from "@/views/base/BaseInput";
  import BaseSelect from "@/views/base/BaseSelect2";
  import BaseFormLoading from "@/views/base/BaseFormLoading";
  import BaseModal from "@/views/base/BaseModal";
  import {DatePicker} from "v-calendar";
  import VideoPlayer from "@/views/base/VideoPlayer";
  import Multiselect from "vue-multiselect";
  
  export default {
    name: "PlayList",
    components: {
      BaseFormLoading,
      BaseTable,
      ModalConfirm,
      BaseInput,
      BaseSelect,
      DatePicker,
      BaseModal,
      VideoPlayer,
      Multiselect
    },
    notifications: {
      showSuccessMsg: {
        type: "success",
        title: "Success",
      },
      showErrorMsg: {
        type: "error",
        title: "Error",
      },
      showWarningMsg: {
        type: "warn",
        title: "warn",
      },
    },
    data() {
      let that = this;
      let actionTypeMapping = new Map();
      actionTypeMapping.set("delete_one", {
        url: "/file-management/delete",
        titlePopup: function () {
          return that.$helper.setupTitleAction(
            "xóa",
            "bản tin",
            that.actionData.model.fileName
          );
        },
        isJsonContentType: false,
        dataSubmit: function () {
          return {
            id: that.actionData.model.fileId
          };
        },
        successCallback: function () {
          that.showSuccessMsg({message: "Xóa bản tin " + that.actionData.model.fileName + " thành công"});
          that.loadDataMainTable();
        }
      });
      return {
        loading: {
          value: false,
        },
        actionData: {
          actionTypeMapping: actionTypeMapping,
          model: {
            selectedAll: false,
            fileId: null,
            fileName: null
          }
        },
        dateRange: {
          start: that.$helper.subtractNowDate(30),
          end: new Date()
        },
        districtCodeInput: {
          options: {
            filter: true,
            label: "Quận/Huyện",
            selectAllText: "Tất cả Quận/Huyện",
            'keyField': 'key',
            'valueField': 'value',
            lazyLoad: (this.$hasAuthor('ROLE_ADMIN')) ? false : true
          },
          data: {
            name: "districtCode",
            items: [],
            model: null,
            source: {
              url: '/common/findByParentCodeAndCode',
              dataSubmit: function () {
                return {}
              },
              response: function (dataResponse) {
                that.districtCodeInput.data.items = dataResponse.data;
              }
            },
          }
        },
        wardCodeInput: {
          options: {
            filter: true,
            label: "Phường/Xã",
            selectAllText: "Tất cả Phường/Xã",
            'keyField': 'key',
            'valueField': 'value',
            lazyLoad: true,
            disabled: true
          },
          data: {
            name: "wardCode",
            model: null,
            items: [],
            source: {
              url: '/common/findByParentCodeAndCode',
              dataSubmit: function () {
                return {
                  parentCode: that.districtCodeInput.data.model
                }
              },
              response: function (dataResponse) {
                that.wardCodeInput.data.items = dataResponse.data;
              }
            },
            updateTrigger: function () {
              return that.$refs.mainTable;
            },
          }
        },
        locationCode: {
          data: {
            name: 'locationCode',
            model: ''
          }
        },
        titleInput: {
          options: {
            placeholder: "Tiêu đề",
            label: "Tiêu đề",
          },
          data: {
            name: "name",
            model: "",
            updateTrigger: function () {
              return that.$refs.mainTable;
            },
          },
        },
        mainTable: {
          options: {
            fields: [
              {key: "index", label: "STT", sorter: false, filter: false, _style: "max-width:5%; width:5%"},
              {key: "createDate", label: "Ngày tạo"},
              {key: "name", label: "Tiêu đề"},
              {key: "description", label: "Mô tả", sorter: false, filter: false},
              {key: "locationName", label: "Địa bàn"},
              {key: "action", label: "Thao tác", sorter: false, filter: false},
            ],
            slots: [
              "index", "createDate", "action", "description", 
            ],
            lazyLoad: this.$hasAuthor('ROLE_WARD') ? true : false,
            pageSize: 10,
            sorter: true,
            columnFilter: false,
            itemsPerPageSelect: {label: ' ', values: [10, 15, 20, 50], external: true},
            tableFilter: {label: 'Bộ lọc:', placeholder: 'Nhập ký tự cần tìm kiếm', external: false, lazy: true},
          },
          dataSource: {
            url: "/play-list/getPages",
            dataSubmit: function () {
              var params = that.$helper.setupDataSubmit(that.$data);
              params.fromDate = that.$helper.formatDateDDMMYYYY(that.dateRange.start);
              params.toDate = that.$helper.formatDateDDMMYYYY(that.dateRange.end);
              return params;
            },
            response: function (dataResponse) {
              return dataResponse.data;
            },
          },
        },
      };
    },
    methods: {
      loadDataMainTable: function (isUpdateFilter) {
        this.$refs.mainTable.loadData(true, isUpdateFilter);
      },
      async downloadFile(item) {
        var url;
        if (item.type == 2) {
          if (item.url && item.pathFolderFile) {
            var itemsFile = item.pathFolderFile.split("/");
            var nameFile = itemsFile[itemsFile.length - 1];
            var urlFile = item.url.substring(0, item.url.lastIndexOf("/"));
            url = urlFile + "/" + nameFile
          }
        } else {
          url = item.url;
        }
        this.loading.value = true;
        const imgUrl = await this.$helper.blobFileByUrl(url);
        this.loading.value = false;
        const a = document.createElement("a");
        document.body.appendChild(a);
        a.href = imgUrl;
        a.download = url.substring(url.lastIndexOf("/") + 1, url.length);
        a.click();
      },
      setupSelectOneAction: function (actionTypeKey, fileId, fileName) {
        let actionData = this.actionData.model;
        actionData.fileId = fileId || null;
        actionData.fileName = fileName || null;
        this.$refs.actionModal.setCurrAction(actionTypeKey);
      },
    },
    created: function () {
    },
    mounted() {
    },
    watch: {
      dateRange: function (newValue) {
        if (newValue) {
          this.loadDataMainTable();
        } else {
          this.dateRange = {
            start: this.$helper.subtractNowDate(30),
            end: new Date()
          }
        }
      },
      'districtCodeInput.data.model': function (value) {
        if (value) {
          this.$refs.wardCodeInput.loadData();
          this.locationCode.data.model = value;
          this.wardCodeInput.options.disabled = false;
        } else {
          this.wardCodeInput.data.items = [];
          this.wardCodeInput.options.disabled = true;
        }
        this.wardCodeInput.data.model = null
      },
      'wardCodeInput.data.model': function (value) {
        if (value) {
          this.locationCode.data.model = value;
        } else {
          this.locationCode.data.model = this.districtCodeInput.data.model;
        }
      },
    },
    computed: {},
  };
  </script>
  <style scoped>
  .td-roles {
    max-width: 250px;
  }
  </style>
  <style>
  .row-2 .form-group {
    margin-top: 0 !important;
  }
  </style>
  <style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
  <style>
  .multiselect.input-error .multiselect__tags {
    border-color: #ff7070;
  }
  </style>
  <style lang="scss">
  
  #fileList {
    .multiselect {
      min-height: 36px !important;
      margin-top: -2px;
  
      &.input-error .multiselect__tags {
        border-color: #ff7070;
      }
  
      .valid-error {
        animation: fade-down ease-out .2s;
        animation-fill-mode: forwards;
      }
  
      .multiselect__tags {
        padding-top: 0px !important;
        min-height: 36px !important;
      }
  
  
      .multiselect__tag {
        margin-top: 5px !important;
        margin-bottom: 0 !important;
      }
    }
  
    .multiselect__input {
      line-height: unset !important;
      font-size: 14px !important;
      padding-top: 5px !important;
    }
  
  
    .multiselect__placeholder {
      padding-top: 7px !important;
      margin: 0 !important;
    }
  }
  </style>
  